import '@oas-ui/i18n'
import { OASFloatButton } from './oas-float-button.js'

if (!customElements.get('oas-float-button')) {
  customElements.define('oas-float-button', OASFloatButton)
}

export { OASFloatButton }
